"use client";

import * as React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const partners = [{
  id: 1,
  name: "Global Systems Group",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619657/img/logo_global_systems.png"
}, {
  id: 2,
  name: "Nexus Infrastructure",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619657/img/logo_nexus_infra.png"
}, {
  id: 3,
  name: "Stratum Dynamics",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619657/img/logo_stratum_dyn.png"
}, {
  id: 4,
  name: "Apex Solutions",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619657/img/logo_apex_solutions.png"
}, {
  id: 5,
  name: "Vanguard Technologies",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619657/img/logo_vanguard_tech.png"
}, {
  id: 6,
  name: "Beacon Advisory",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619657/img/logo_beacon_advisory.png"
}];
export default function CertifiedExcellence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="126306" id="industry-validation" className="bg-background py-12 overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="bg-card/20 rounded-none py-10 px-6 md:px-12 flex flex-col items-center justify-center gap-8 border-y border-border/30 shadow-none">
          <p className="text-[10px] font-mono text-primary uppercase tracking-[0.3em] text-center">
            Strategic Alliances & Technical Validations
          </p>
          
          <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-10 w-full max-w-5xl mx-auto">
            {partners.map((partner, i) => <div key={partner.id} data-index={i} className="flex items-center justify-center group cursor-pointer">
                <img src={partner.logo} alt={`${partner.name} logo`} className="h-8 md:h-10 w-auto object-contain grayscale opacity-40 transition-all duration-500 ease-in-out group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}